import { toast } from 'sonner';

/**
 * Surface AI detection errors returned by the backend (color / sentiment).
 * Backend shape:
 *   data.detection_errors: [{ stage, code, message, raw_response?, admin: bool }]
 *
 * Admins see the raw error message; regular users see the friendly message
 * (already formatted by the backend) and are nudged to report it.
 */
export function showDetectionErrors(data) {
  const errors = data?.detection_errors;
  if (!Array.isArray(errors) || errors.length === 0) return;

  errors.forEach((err) => {
    const msg = err?.message || 'AI detection failed. Please try again later.';
    if (err?.admin && err?.raw_response) {
      toast.error(msg, {
        description: `code=${err.code} | response: ${String(err.raw_response).slice(0, 200)}`,
        duration: 10000,
      });
    } else if (err?.admin) {
      toast.error(msg, {
        description: `code=${err.code}`,
        duration: 8000,
      });
    } else {
      toast.error(msg, { duration: 6000 });
    }
  });
}
